import { LinkHandler } from '../link-handler';
import { BalloonTaskHandler, BalloonCommentHandler } from './tool-components';

export const balloonTools = {
  link: {
    group: 'link',
    items: [
      {
        key: 'link',
        label: 'toolbar.link',
        Component: LinkHandler,
        haveItsOwnHandler: true,
      },
    ],
  },
  comment: {
    group: 'comment',
    items: [
      {
        key: 'insertCommentCommand',
        label: 'toolbar.add_comment',
        Component: BalloonCommentHandler,
        haveItsOwnHandler: true,
      },
    ],
  },
  task: {
    group: 'task',
    items: [
      {
        key: 'insertTaskCommand',
        label: 'toolbar.add_task',
        Component: BalloonTaskHandler,
        haveItsOwnHandler: true,
      },
    ],
  },
};
